import React, { useEffect } from "react"
import { graphql, PageProps } from "gatsby"
import { getPageData } from "../helpers/getPageData"
import { PageData } from "../interfaces/pageProps"

import Layout from "../components/Layouts/mainPage"
import { NewHeader } from "../components/Headers/NewHeader"
import { Banner } from "../components/Banners/Invite"
import { FourAdvantagesPoints } from "../components/FourAdvantagesPoints"
import { LowerBanner } from "../components/LowerBanner"
import { HowSteps } from "../components/HowSteps"
import { STEPS_INVITEFRIEND } from "../components/HowSteps/helpers"
import { FormPKW } from "../components/FormPKW"
import { GridWithTooltip } from "../components/GridWithTooltip"
import { CARDS_INVITEFRIEND } from "../components/GridWithTooltip/helper"
import { NewCalculator } from "../components/NewCalculator"
import { Partners } from "../components/PartnersNew"
import { autoPromo } from "../components/PartnersNew/helpers"
import { Questions } from "../components/Questions"
import { QUESTIONS_FOR_INVITE_FRIEND } from "../components/Questions/helpers"
import { NewFooter } from "../components/NewFooter"

const titleLowerBanner = (
  <>
    1 000 баллов = 1 000 ₽ <br className="d-sm-none d-md-block" />
    на любые покупки
  </>
)

const descrLowerBanner = (
  <ul>
    <li>— Получите баллы за оформление карты «Халва» по&nbsp;приглашению друга</li>
    <li>
      — Вы можете их использовать, чтобы заплатить за&nbsp;такси, кофе, продукты и&nbsp;любые другие
      покупки: просто выберите оплату баллами в&nbsp;приложении «Халва»
    </li>
    <li>— Баллы начислим сразу после первого платежа</li>
  </ul>
)

const titleLowerBannerGethalva = (
  <>
    Получите Халву так, <br />
    как вам удобно
  </>
)

const descrLowerBannerGethalva = (
  <ul>
    <li>
      – Бесплатная доставка курьером <br />
      на следующий день
    </li>
    <li>– Самовывоз из офиса банка</li>
  </ul>
)

const titleGridWithTooltip = <>Что даёт подписка «Халва.Десятка»</>

const descrGridWithTooltip = (
  <>Подключим на месяц бесплатно, чтобы вы&nbsp;протестировали все&nbsp;её&nbsp;возможности</>
)

const titleForm = <>Оформите карту сейчас</>

const subtitleForm = (
  <>
    Получите месяц подписки <br className="d-sm-none" />
    «Халва.Десятка» в подарок
  </>
)

const subTitlePartners = <>Делайте покупки у партнёров с рассрочкой* до&nbsp;24&nbsp;месяцев</>

const textTooltipCalculator = (
  <>
    «Халва» объединяет возможности кредитной и&nbsp;дебетовой карты. Её&nbsp;можно использовать
    для&nbsp;повседневных трат и&nbsp;для крупных покупок в&nbsp;рассрочку*. При&nbsp;оформлении
    «Халвы» мы рассчитываем ваш кредитный лимит для&nbsp;рассрочки*, чтобы предложить лучшие условия
    по&nbsp;срокам и&nbsp;повысить шанс на&nbsp;одобрение
  </>
)

// Время для таймер(30мин)
const countDownTime = 1800000

export default function Page({ data }: PageProps<PageData>) {
  const { ligal, noIndex } = getPageData(data)

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  return (
    <Layout noHeader noFooter noIndex={noIndex}>
      <NewHeader redLogoWithSovcombank countDownTime={countDownTime} />
      <Banner orderNum="1" />
      <FourAdvantagesPoints
        withTitle
        variant="inviteFriend"
        title="Ваша выгода с Халвой"
        orderNum="2"
      />
      <LowerBanner title={titleLowerBanner} descr={descrLowerBanner} orderNum="3" />
      <HowSteps title="Как это работает" items={STEPS_INVITEFRIEND} orderNum="3" />
      <FormPKW
        title={titleForm}
        subTitle={subtitleForm}
        longTitle
        longForm
        countDownTime={countDownTime}
        withTimer
        formBtnText="Оформить карту"
        isGreenApprove
        progressBar
        orderNum="5"
      />
      <GridWithTooltip
        headTitle={titleGridWithTooltip}
        headDescr={descrGridWithTooltip}
        dataContent={CARDS_INVITEFRIEND}
        orderNum="6"
      />
      <NewCalculator
        variantStyles="invitefriend"
        textTooltip={textTooltipCalculator}
        orderNum="7"
      />
      <Partners
        title="Более 260&nbsp;000 магазинов-партнеров"
        subTitle={subTitlePartners}
        additionalPartners={autoPromo}
        variantStyle="invitefriend"
        orderNum="8"
      />
      <LowerBanner
        variant="gethalva"
        title={titleLowerBannerGethalva}
        descr={descrLowerBannerGethalva}
        orderNum="9"
      />
      <Questions questionList={QUESTIONS_FOR_INVITE_FRIEND} orderNum="10" />
      <NewFooter ligal={ligal} orderNum="11" />
    </Layout>
  )
}

export const query = graphql`
  query {
    admin {
      page(url: "https://halvacard.ru/order/invitefriend/") {
        url
        phones
        ligal {
          text
        }
        notIndex
      }
      halvaOstatok: variable(name: "halvaOstatok") {
        value
      }
    }
  }
`
